import Image from 'next/image'
import Link from 'next/link'

interface LogoProps {
    href?: string
    className?: string
}

export function Logo({ href = '/', className = '' }: LogoProps) {
    const logoContent = (
        <div className={`flex items-center gap-2 ${className}`}>
            <div className="relative p-1.5 flex items-center justify-center w-7.75 h-7.25 btn-gradient-blue rounded-[0.5rem]">
                <Image
                    src="https://wlrmvbskipy8hftc.public.blob.vercel-storage.com/logos/insighthread-logo-w.png"
                    alt="InsightThread Logo"
                    fill
                    sizes="32px"
                    className="object-contain m-auto"
                />
            </div>
            <p className="font-medium text-base text-[#1D1D1F]">Insighthread</p>
        </div>
    )

    if (href) {
        return <Link href={href}>{logoContent}</Link>
    }

    return logoContent
}
